var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ttam-tip-box',{attrs:{"text":_vm.$t('module_ios14_web_pixel_hint'),"link-text":_vm.$t('common_go_to_web_event_configuration'),"width":"552px","link-url":_vm.url}})}
var staticRenderFns = []

export { render, staticRenderFns }